import { render, staticRenderFns } from "./ReserveForm.vue?vue&type=template&id=66822f2f"
import script from "./ReserveForm.vue?vue&type=script&lang=js"
export * from "./ReserveForm.vue?vue&type=script&lang=js"
import style0 from "./ReserveForm.vue?vue&type=style&index=0&id=66822f2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports